import { render, staticRenderFns } from "./AddSingleScooterStep2.vue?vue&type=template&id=4650d6b6&scoped=true"
import script from "./AddSingleScooterStep2.vue?vue&type=script&lang=js"
export * from "./AddSingleScooterStep2.vue?vue&type=script&lang=js"
import style0 from "./AddSingleScooterStep2.vue?vue&type=style&index=0&id=4650d6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650d6b6",
  null
  
)

export default component.exports